module.exports = __webpack_public_path__ + "img/mail.ccf596b1.svg";